"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.onlyText = exports.deepFind = exports.deepForEach = exports.deepMap = exports.groupByType = exports.deepFilter = exports.filter = exports.hasComplexChildren = exports.hasChildren = void 0;

var _react = require("react");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var hasChildren = function hasChildren(child) {
  return Boolean(child && child.props && child.props.children);
};

exports.hasChildren = hasChildren;

var hasComplexChildren = function hasComplexChildren(child) {
  return hasChildren(child) && _typeof(child.props.children) === "object";
};

exports.hasComplexChildren = hasComplexChildren;

var filter = function filter(children, filterFn) {
  return _react.Children.toArray(children).filter(filterFn);
};

exports.filter = filter;

var deepFilter = function deepFilter(children, deepFilterFn) {
  return _react.Children.toArray(children).filter(deepFilterFn).map(function (child) {
    if (hasComplexChildren(child)) {
      return (0, _react.cloneElement)(child, _objectSpread({}, child.props, {
        children: deepFilter(child.props.children, deepFilterFn)
      }));
    }

    return child;
  });
};

exports.deepFilter = deepFilter;

var groupByType = function groupByType(children, types, rest) {
  return _react.Children.toArray(children).reduce(function (group, child) {
    var isGrouped = types.includes(child.type);
    var addChild = isGrouped ? child.props.children : child;
    var key = isGrouped ? child.type : rest;
    return _objectSpread({}, group, _defineProperty({}, key, [].concat(_toConsumableArray(group[key] || []), [addChild])));
  }, {});
};

exports.groupByType = groupByType;

var deepMap = function deepMap(children, deepMapFn) {
  return _react.Children.map(children, function (child) {
    if (hasComplexChildren(child)) {
      return deepMapFn((0, _react.cloneElement)(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, deepMapFn)
      })));
    }

    return deepMapFn(child);
  });
};

exports.deepMap = deepMap;

var deepForEach = function deepForEach(children, deepForEachFn) {
  _react.Children.forEach(children, function (child) {
    if (hasComplexChildren(child)) {
      deepForEach(child.props.children, deepForEachFn);
    }

    deepForEachFn(child);
  });
};

exports.deepForEach = deepForEach;

var deepFind = function deepFind(children, deepFindFn) {
  var found;

  _react.Children.toArray(children).find(function (child) {
    if (hasComplexChildren(child)) {
      found = deepFind(child.props.children, deepFindFn);
      return typeof found !== "undefined";
    }

    if (deepFindFn(child)) {
      found = child;
      return true;
    }

    return false;
  });

  return found;
};

exports.deepFind = deepFind;

var onlyText = function onlyText(children) {
  return _react.Children.toArray(children).reduce(function (flattened, child) {
    return [].concat(_toConsumableArray(flattened), [hasChildren(child) ? onlyText(child.props.children) : child]);
  }, []).join("");
};

exports.onlyText = onlyText;

var _default = _objectSpread({}, _react.Children, {
  filter: filter,
  deepFilter: deepFilter,
  groupByType: groupByType,
  deepMap: deepMap,
  deepForEach: deepForEach,
  deepFind: deepFind,
  onlyText: onlyText,
  hasChildren: hasChildren,
  hasComplexChildren: hasComplexChildren
});

exports["default"] = _default;